import { useState, useEffect } from 'react';
import { getTransactions } from '../api';

export default function TransactionsPage() {
  const [txs, setTxs]         = useState([]);
  const [loading, setLoading] = useState(true);
  const [type, setType]       = useState('');
  const [status, setStatus]   = useState('completed');

  useEffect(() => { loadTxs(); }, [type, status]);

  async function loadTxs() {
    setLoading(true);
    try { const res = await getTransactions({ type, status, limit:100 }); setTxs(res); }
    catch (err) { console.error(err); }
    finally { setLoading(false); }
  }

  function formatDate(ts) {
    return new Date(ts*1000).toLocaleDateString('en-US',{month:'short',day:'numeric',hour:'numeric',minute:'2-digit'});
  }

  const typeColors = {
    deposit:'#00C48C', receive:'#00C48C', payment_received:'#00C48C',
    send:'#FF3B30', cashout_spend:'#FF9500', cashout_save:'#FF9500',
    payment:'#FF3B30', spend_to_save:'#007AFF', save_to_spend:'#007AFF'
  };

  const totalVolume = txs.reduce((sum, tx) => sum + parseFloat(tx.amountUsd||0), 0);
  const totalFees   = txs.reduce((sum, tx) => sum + parseFloat(tx.feeUsd||0), 0);

  return (
    <div>
      <div style={s.header}>
        <div>
          <h1 style={s.title}>Transactions</h1>
          <p style={s.subtitle}>All platform transactions</p>
        </div>
        <div style={s.summaryRow}>
          <div style={s.summaryCard}>
            <div style={s.summaryLabel}>Showing volume</div>
            <div style={s.summaryValue}>${totalVolume.toFixed(2)}</div>
          </div>
          <div style={s.summaryCard}>
            <div style={s.summaryLabel}>Showing fees</div>
            <div style={{...s.summaryValue, color:'#00C48C'}}>${totalFees.toFixed(2)}</div>
          </div>
        </div>
      </div>

      <div style={s.filters}>
        <select style={s.select} value={type} onChange={e => setType(e.target.value)}>
          <option value="">All types</option>
          <option value="deposit">Deposit</option>
          <option value="send">Send</option>
          <option value="receive">Receive</option>
          <option value="cashout_spend">Cashout Spend</option>
          <option value="cashout_save">Cashout Earning</option>
          <option value="payment">Payment</option>
          <option value="payment_received">Payment Received</option>
          <option value="spend_to_save">Spend to Earning</option>
          <option value="save_to_spend">Earning to Spend</option>
        </select>
        <select style={s.select} value={status} onChange={e => setStatus(e.target.value)}>
          <option value="">All statuses</option>
          <option value="completed">Completed</option>
          <option value="pending">Pending</option>
          <option value="processing">Processing</option>
        </select>
      </div>

      {loading ? <div style={s.loading}>Loading...</div> : (
        <div style={s.tableWrap}>
          <div style={s.tableHeader}>
            <span style={{flex:2}}>User</span>
            <span style={{flex:1.5}}>Type</span>
            <span style={{flex:1}}>Amount</span>
            <span style={{flex:1}}>Fee</span>
            <span style={{flex:1}}>Net</span>
            <span style={{flex:1.5}}>Date</span>
            <span style={{flex:1}}>Status</span>
          </div>
          {txs.length === 0 ? (
            <div style={s.empty}>No transactions found</div>
          ) : txs.map(tx => (
            <div key={tx.id} style={s.tableRow}>
              <span style={{flex:2, fontSize:13, fontWeight:500}}>{tx.userName||'—'}</span>
              <span style={{flex:1.5}}>
                <span style={{fontSize:12, fontWeight:600, color:typeColors[tx.type]||'#6E6E73', textTransform:'capitalize'}}>
                  {({
                    spend_to_save:  'Spend to Earning',
                    save_to_spend:  'Earning to Spend',
                    spend_to_stack: 'Spend to Earning',
                    stack_to_spend: 'Earning to Spend',
                    cashout_spend:  'Cashout Spend',
                    cashout_save:   'Cashout Earning',
                    payment_received: 'Payment Received',
                  })[tx.type] || tx.type?.replace(/_/g,' ')}
                </span>
              </span>
              <span style={{flex:1, fontSize:13, fontWeight:600}}>${tx.amountUsd}</span>
              <span style={{flex:1, fontSize:13, color:'#6E6E73'}}>${tx.feeUsd}</span>
              <span style={{flex:1, fontSize:13, fontWeight:500}}>${tx.netUsd}</span>
              <span style={{flex:1.5, fontSize:12, color:'#6E6E73'}}>{formatDate(tx.createdAt)}</span>
              <span style={{flex:1}}>
                <span style={{fontSize:11, fontWeight:600, padding:'3px 8px', borderRadius:6,
                  background: tx.status==='completed'?'#E6FAF5':tx.status==='pending'?'#FFF9EC':'#FFF0EF',
                  color:      tx.status==='completed'?'#00C48C':tx.status==='pending'?'#FF9500':'#FF3B30'}}>
                  {tx.status}
                </span>
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const s = {
  header:      {display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:20},
  title:       {fontSize:24, fontWeight:700},
  subtitle:    {fontSize:14, color:'#6E6E73', marginTop:4},
  summaryRow:  {display:'flex', gap:12},
  summaryCard: {background:'#fff', borderRadius:12, padding:'12px 16px', boxShadow:'0 2px 20px rgba(0,0,0,0.06)', minWidth:120},
  summaryLabel:{fontSize:11, color:'#6E6E73', marginBottom:4},
  summaryValue:{fontSize:18, fontWeight:700},
  filters:     {display:'flex', gap:10, marginBottom:16},
  select:      {padding:'10px 14px', background:'#fff', border:'1.5px solid #F0F0F0', borderRadius:10, fontSize:13, outline:'none'},
  loading:     {color:'#6E6E73', padding:20},
  tableWrap:   {background:'#fff', borderRadius:16, overflow:'hidden', boxShadow:'0 2px 20px rgba(0,0,0,0.06)'},
  tableHeader: {display:'flex', padding:'12px 20px', background:'#F5F5F7', fontSize:11, fontWeight:600, color:'#6E6E73', textTransform:'uppercase', letterSpacing:0.5},
  tableRow:    {display:'flex', padding:'14px 20px', borderBottom:'1px solid #F5F5F7', alignItems:'center'},
  empty:       {padding:40, textAlign:'center', color:'#AEAEB2', fontSize:14}
};
